import '../scss/front.scss'

// Bootstrap: import only the JS components the theme actually uses. Saves
// bandwidth vs shipping the full bootstrap.bundle.min.js. Each module's
// side-effect registers its data-bs-toggle="…" data-API. Grep for
// `data-bs-toggle` in the twig templates before removing any of these.
//
// We import from `bootstrap/js/src/*.js` (pure ESM) instead of
// `bootstrap/js/dist/*.js` (UMD wrappers) because the UMD interop confused
// webpack + terser in prod ("TypeError: n.r is not a function" thrown from
// util/config.js). ESM source lets webpack tree-shake cleanly and emit the
// namespace helpers correctly.
import 'bootstrap/js/src/collapse'
import 'bootstrap/js/src/dropdown'
import 'bootstrap/js/src/modal'
import 'bootstrap/js/src/offcanvas'

import { initMenu } from './components/menu.js'

const partials = import.meta.webpackContext('../../views/partial', {
  mode: 'eager',
  regExp: /scripts\/_partial\.js$/
})
const views = import.meta.webpackContext('../../views', {
  mode: 'eager',
  regExp: /scripts\/_view\.js$/
})

// Execute all imported modules
const importModules = async (modules) => {
  for (const key of modules.keys()) {
    const module = await modules(key)
    if (module.default) {
      module.default()
    }
  }
}

const initViews = async () => {
  await importModules(views)
  await importModules(partials)
}

window.addEventListener('DOMContentLoaded', () => {
  initViews()
  initMenu()
})
